const supportedIndexImageLocales = ['ja', 'pt', 'ko'] as const

type SupportedIndexImageLocale = (typeof supportedIndexImageLocales)[number]
type LocalizedIndexImageMap = Partial<Record<SupportedIndexImageLocale, string>>

export const getLocalizedIndexImage = (
  locale: string,
  fallback: string,
  localizedImages: LocalizedIndexImageMap,
) => {
  return localizedImages[locale as SupportedIndexImageLocale] ?? fallback
}

export const aiThinkingImages = {
  ja: '/images/index/all-images/ai-thinking-ja.png',
  pt: '/images/index/all-images/ai-thinking-pt.png',
  ko: '/images/index/all-images/ai-thinking-ko.png',
} satisfies LocalizedIndexImageMap

export const proPromptsImages = {
  ja: '/images/index/all-images/pro-prompts-ja.png',
  pt: '/images/index/all-images/pro-prompts-pt.png',
  ko: '/images/index/all-images/pro-prompts-ko.png',
} satisfies LocalizedIndexImageMap

export const safeFromImages = {
  ja: '/images/index/all-images/safe-from-ja.png',
  pt: '/images/index/all-images/safe-from-pt.png',
  ko: '/images/index/all-images/safe-from-ko.png',
} satisfies LocalizedIndexImageMap

export const createDownloadImages = {
  ja: '/images/index/all-images/create-download-ja.png',
  pt: '/images/index/all-images/create-download-pt.png?t=1',
  ko: '/images/index/all-images/create-download-ko.png',
} satisfies LocalizedIndexImageMap

export const howToStep01Images = {
  ja: '/images/index/all-images/how-to-step-01-ja.png',
  pt: '/images/index/all-images/how-to-step-01-pt.png',
  ko: '/images/index/all-images/how-to-step-01-ko.png',
} satisfies LocalizedIndexImageMap

export const howToStep02Images = {
  ja: '/images/index/all-images/how-to-step-02-ja.png',
  pt: '/images/index/all-images/how-to-step-02-pt.png',
  ko: '/images/index/all-images/how-to-step-02-ko.png',
} satisfies LocalizedIndexImageMap

export const howToStep03Images = {
  ja: '/images/index/all-images/how-to-step-03-ja.png',
  pt: '/images/index/all-images/how-to-step-03-pt.png?t=1',
  ko: '/images/index/all-images/how-to-step-03-ko.png',
} satisfies LocalizedIndexImageMap

export const whoIsImages = {
  musicians: {
    ja: '/images/index/all-images/who-is-musicians-ja.png',
    pt: '/images/index/all-images/who-is-musicians-pt.png',
    ko: '/images/index/all-images/who-is-musicians-ko.png',
  },
  videoContentCreators: {
    ja: '/images/index/all-images/who-is-video-content-creators-ja.png',
    pt: '/images/index/all-images/who-is-video-content-creators-pt.png',
    ko: '/images/index/all-images/who-is-video-content-creators-ko.png',
  },
  businesses: {
    ja: '/images/index/all-images/who-is-businesses-ja.png',
    pt: '/images/index/all-images/who-is-businesses-pt.png',
    ko: '/images/index/all-images/who-is-businesses-ko.png',
  },
  hobbyists: {
    ja: '/images/index/all-images/who-is-hobbyists-ja.png',
    pt: '/images/index/all-images/who-is-hobbyists-pt.png',
    ko: '/images/index/all-images/who-is-hobbyists-ko.png',
  },
} satisfies Record<string, LocalizedIndexImageMap>
